import React, {ComponentProps, useEffect, useState} from 'react';
import {getDocument} from 'src/appApi';

interface PDFProps extends React.ComponentPropsWithoutRef<'iframe'> {
  filename: string;
  uri: string;
}

const PDF = ({uri, filename, ...rest}: PDFProps) => {
  const [link, setLink] = useState<string | null>(null);

  useEffect(() => {
    let ignore = false;
    const fetchDocumentLink = async () => {
      if (uri.includes('get_read_url')) {
        // unsigned url
        const response = await getDocument(uri);
        if (!ignore) {
          setLink(response.data);
        }
        return;
      }
      // signed url
      if (!ignore) {
        setLink(uri);
      }
    };
    fetchDocumentLink();
    return () => {
      ignore = true;
    };
  }, [uri]);
  if (link === null) {
    return null;
  }
  return <iframe key={link} src={link} title={filename} {...rest} />;
};

export default PDF;
